import React from 'react';
import { Search, Sparkles } from 'lucide-react'; // Trocado para Lucide para manter a elegância
import { useSearchBar } from '../hooks/useSearchBar';

// --- Opções de Filtro ---
const playerOptions = [
    { value: '', label: 'Qualquer' },
    { value: 'duelo', label: 'Duelo' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5+' },
];

const durationOptions = [
    { value: '', label: 'Qualquer' },
    { value: 'short', label: '<30min' },
    { value: 'medium', label: '30-60min' },
    { value: 'long', label: '60min+' },
];

// --- Sub-componente Estético V2 (Filtros estilo "Pill/Etiqueta") ---
const SegmentedControlV2 = ({ label, options, selectedValue, onChange }) => (
    <div className="flex flex-col items-center md:items-start gap-3">
        <span className="font-serif text-sm tracking-[0.2em] text-[#528a89] uppercase flex items-center gap-2">
            <Sparkles size={12} className="text-[#dbcdac]"/> {label}
        </span>
        <div className="flex flex-wrap justify-center items-center bg-[#FFF5EE]/80 border border-[#dbcdac]/50 rounded-full p-1.5 shadow-inner">
            {options.map((opt) => {
                const isSelected = selectedValue === opt.value;
                return (
                    <button
                        key={opt.label}
                        type="button"
                        onClick={() => onChange(opt.value)}
                        className={`
                            px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider transition-all duration-300
                            ${isSelected 
                                ? 'bg-[#528a89] text-[#FFF5EE] shadow-md transform scale-105' 
                                : 'text-stone-500 hover:text-[#971253] hover:bg-[#dbcdac]/20'
                            }
                        `}
                    >
                        {opt.label}
                    </button>
                )
            })}
        </div>
    </div>
);

// --- Componente Principal ---
function SearchBar({ initialParams, onSearch }) {
    
    // A LÓGICA PERMANECE INTACTA!
    const { formData, handleInputChange, handleFilterChange, handleSubmit } = useSearchBar(initialParams, onSearch);

    return (
        <form onSubmit={handleSubmit} className="flex flex-col gap-8 w-full">
            
            {/* 1. CAMPO DE BUSCA PRINCIPAL */}
            <div className="relative flex items-center w-full max-w-3xl mx-auto group">
                <input 
                    type="text" 
                    name="search"
                    value={formData.search || ''}
                    onChange={handleInputChange}
                    placeholder="Buscar jogos, temas ou palavras-chave..."
                    // Suavizei a cor da borda no focus para combinar melhor com o botão
                    className="w-full bg-[#FFF5EE]/80 border-2 border-[#dbcdac]/40 rounded-full py-4 pl-8 pr-16 font-serif text-xl text-[#971253] placeholder:text-stone-400 placeholder:italic focus:outline-none focus:border-[#528a89]/50 focus:bg-white focus:ring-4 focus:ring-[#528a89]/10 transition-all shadow-inner"
                />
                
                <button 
                    type="submit" 
                    // Novo estilo: Círculo perfeito, fundo suave esmeralda, hover preenchido
                    className="absolute right-2.5 top-1/2 -translate-y-1/2 w-11 h-11 flex items-center justify-center rounded-full text-[#528a89] bg-[#528a89]/10 hover:bg-[#528a89] hover:text-[#FFF5EE] transition-all duration-300 focus:outline-none"
                >
                    <Search size={20} strokeWidth={1.5} />
                </button>
            </div>
            
            {/* DIVISOR DECORATIVO EDITORIAL */}
            <div className="flex items-center justify-center gap-4 opacity-70 my-2">
                <div className="h-[1px] w-12 md:w-32 bg-gradient-to-r from-transparent to-[#dbcdac]"></div>
                <span className="font-serif text-xs text-[#dbcdac] uppercase tracking-[0.3em]">Refinar Busca</span>
                <div className="h-[1px] w-12 md:w-32 bg-gradient-to-l from-transparent to-[#dbcdac]"></div>
            </div>

            {/* 2. LINHA DE FILTROS (SEGMENTED CONTROLS) */}
            <div className="flex flex-col md:flex-row justify-center items-center gap-8 md:gap-16">
                <SegmentedControlV2
                    label="Nº de Jogadores"
                    options={playerOptions}
                    selectedValue={formData.qt_jogadores || ''} 
                    onChange={(value) => handleFilterChange('qt_jogadores', value)} 
                />
                
                <SegmentedControlV2
                    label="Duração da Partida"
                    options={durationOptions}
                    selectedValue={formData.duracao || ''} 
                    onChange={(value) => handleFilterChange('duracao', value)}
                />
            </div>

        </form>
    );
}

export default SearchBar;